import { get, post } from "../common/dataFetch";
import { QuestionManagementEntry } from "../store/questionManagement";
import { WebControllers } from "../constants/webControllers";
import { WebActionNames } from "../constants/webActionNames";

export const createAsync = (questionManagementEntry: Omit<QuestionManagementEntry, 'id'>) => post<number, Omit<QuestionManagementEntry, 'id'>>(WebControllers.QuestionManagement, WebActionNames.CreateAsync, questionManagementEntry);

export const readCollectionAsync = () => get<QuestionManagementEntry[]>(WebControllers.QuestionManagement, WebActionNames.ReadNoParamsAsync);

export const deleteAsync = (questionManagementEntry: Pick<QuestionManagementEntry, 'id'>) => post<number, Pick<QuestionManagementEntry, 'id'>>(WebControllers.QuestionManagement, WebActionNames.DeleteAsync, questionManagementEntry);